import React, { useEffect, useRef, useState } from "react";
import { EMOJI_CATEGORIES } from "../utils/emojiCategories";
import "./EmojiPicker.css";

/**
 * Shared emoji grid (same sets as chat composer).
 * @param {(emoji: string) => void} onSelect
 * @param {string} [className]
 * @param {'up'|'down'} [placement]
 */
const EmojiPicker = ({ onSelect, className = "", placement = "down" }) => {
  const [category, setCategory] = useState(EMOJI_CATEGORIES[0].id);
  const active = EMOJI_CATEGORIES.find((c) => c.id === category) || EMOJI_CATEGORIES[0];

  return (
    <div className={`emoji-picker emoji-picker-${placement} ${className}`.trim()}>
      <div className="emoji-picker-tabs">
        {EMOJI_CATEGORIES.map((cat) => (
          <button
            key={cat.id}
            type="button"
            className={`emoji-picker-tab ${category === cat.id ? "active" : ""}`}
            title={cat.title}
            onClick={() => setCategory(cat.id)}
          >
            {cat.label}
          </button>
        ))}
      </div>
      <div className="emoji-picker-grid">
        {(active.emojis || []).map((emoji, index) => (
          <button
            key={`${emoji}-${index}`}
            type="button"
            className="emoji-picker-item"
            onClick={() => onSelect?.(emoji)}
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  );
};

/** Field control: pick one emoji (chatbot reaction, etc.). */
export const EmojiReactionField = ({ value = "", onChange, label = "Reaction emoji (optional)" }) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [open]);

  return (
    <label className="emoji-reaction-field">
      {label}
      <div className="emoji-reaction-wrap" ref={wrapRef}>
        <div className="emoji-reaction-row">
          <button
            type="button"
            className={`emoji-reaction-trigger ${open ? "is-open" : ""}`}
            onClick={() => setOpen((v) => !v)}
            aria-expanded={open}
          >
            <span className="emoji-reaction-preview" aria-hidden="true">
              {value || "🙂"}
            </span>
            <span className="emoji-reaction-text">
              {value ? "Change emoji" : "Select emoji"}
            </span>
          </button>
          {value ? (
            <button
              type="button"
              className="emoji-reaction-clear"
              onClick={() => {
                onChange?.("");
                setOpen(false);
              }}
            >
              Clear
            </button>
          ) : null}
        </div>
        {open ? (
          <EmojiPicker
            placement="down"
            onSelect={(emoji) => {
              onChange?.(emoji);
              setOpen(false);
            }}
          />
        ) : null}
      </div>
    </label>
  );
};

export default EmojiPicker;
